import { useEffect, useRef } from 'react';
import LogoSplash from '../components/LogoSplash.jsx';
import Hero from '../components/Hero.jsx';
import QuickLinks from '../components/QuickLinks.jsx';
import AirportInformation from '../components/AirportInformation.jsx';
import FlightBoard from '../components/FlightBoard.jsx';
import PassengerServices from '../components/PassengerServices.jsx';
import AirportFacilities from '../components/AirportFacilities.jsx';
import ExploreMauritania from '../components/ExploreMauritania.jsx';
import Testimonials from '../components/Testimonials.jsx';
import {
  AdvertiseSection,
  CtaSection,
  NewsSection,
  StatsSection,
  WhyChoose,
} from '../components/HomeSections.jsx';
import { useRevealOnScroll } from '../hooks/useRevealOnScroll.js';
import { useStatCounters } from '../hooks/useStatCounters.js';

export default function HomePage() {
  const mainRef = useRef(null);
  useRevealOnScroll(mainRef);
  useStatCounters(mainRef);

  useEffect(() => {
    document.documentElement.classList.add('v4-splash-pending');
    return () => {
      document.documentElement.classList.remove('v4-splash-pending');
    };
  }, []);

  return (
    <main id="main" ref={mainRef}>
      <LogoSplash />
      <Hero />
      <QuickLinks />
      <AirportInformation />
      <FlightBoard />
      <PassengerServices />
      <AirportFacilities />
      <ExploreMauritania />
      <NewsSection />
      <StatsSection />
      <WhyChoose />
      <AdvertiseSection />
      <Testimonials />
      <CtaSection />
    </main>
  );
}
